export enum FilesCategoryEnum {
  INSTRUMENTO_PUBLICO_CESSAO = "INSTRUMENTO_PUBLICO_CESSAO",
  INSTRUMENTO_PUBLICO_MANDATO = "INSTRUMENTO_PUBLICO_MANDATO",
  TERMO_CESSAO = "TERMO_CESSAO",
  TERMO_CONDICOES_GERAIS = "TERMO_CONDICOES_GERAIS",
  TERMO_ACEITE = "TERMO_ACEITE",
  CAPA_DO_PROCESSO = "CAPA_DO_PROCESSO",
  SUBSTABELECIMENTO = "SUBSTABELECIMENTO",
  OUTROS = "OUTROS",
  ENTUBA_EXPOSURE_VALUE = "ENTUBA_EXPOSURE_VALUE",
  PRINCING_BATCH = "PRINCING_BATCH",
  OFFICER_INSTRUCTIONS = "OFFICER_INSTRUCTIONS",
  BCHECK_BATCH = "BCHECK_BATCH",
  ENTUBA_PRINCING = "ENTUBA_PRINCING",
  ENTUBA_BCHECK = "ENTUBA_BCHECK",
  FILE_PROCURACAO_AD_JUDICIA_PRIVADA = "FILE_PROCURACAO_AD_JUDICIA_PRIVADA",
  FILE_PROCURACAO_AD_JUDICIA_PUBLICA = "FILE_PROCURACAO_AD_JUDICIA_PUBLICA",
  CESSAO_FIDUCIARIA = "CESSAO_FIDUCIARIA",
  CDB = "CDB",
  TED_DOCUMENT = "TED_DOCUMENT",
  PIX_DOCUMENT = "PIX_DOCUMENT",
  BOLETO_DOCUMENT = "BOLETO_DOCUMENT",
  EXPENSE_BATCH = "EXPENSE_BATCH",
  TRADE_BATCH = "TRADE_BATCH",
  ORIGINATION_BATCH = "ORIGINATION_BATCH",
  FEE_PAYMENT_BATCH = "FEE_PAYMENT_BATCH",
  RECONCILE_SETTLEMENT_BATCH = "RECONCILE_SETTLEMENT_BATCH",
  TOGGLE_ACCRUAL_BATCH = "TOGGLE_ACCRUAL_BATCH",
  INSTRUMENTO_PARTICULAR_CESSAO = "INSTRUMENTO_PARTICULAR_CESSAO",
  WHOLESALE = "WHOLESALE",
  DECLARACAO_NAO_CONSTRICAO = "DECLARACAO_NAO_CONSTRICAO",
  EBOOK_TUTORIAL = "EBOOK_TUTORIAL",
  AVERAGE_DISCOUNT = "AVERAGE_DISCOUNT",
  RTB_DATA = "RTB_DATA",
  MOTOR_CREDITO_RTB_DATA = "MOTOR_CREDITO_RTB_DATA",
  AGENT_ORCHESTRATOR_DATA = "AGENT_ORCHESTRATOR_DATA"
}

export const FilesCategoryEnumLabel = new Map<FilesCategoryEnum, string>([
  [FilesCategoryEnum.INSTRUMENTO_PUBLICO_CESSAO, "Instrumento publico de cessão"],
  [FilesCategoryEnum.INSTRUMENTO_PUBLICO_MANDATO, "Instrumento publico de mandato"],
  [FilesCategoryEnum.TERMO_CESSAO, "Termo de cessão"],
  [FilesCategoryEnum.TERMO_CONDICOES_GERAIS, "Termos e condições gerais"],
  [FilesCategoryEnum.TERMO_ACEITE, "Termo de aceite"],
  [FilesCategoryEnum.CAPA_DO_PROCESSO, "Capa do processo"],
  [FilesCategoryEnum.SUBSTABELECIMENTO, "Substabelecimento"],
  [FilesCategoryEnum.OUTROS, "Outros"],
  [FilesCategoryEnum.ENTUBA_EXPOSURE_VALUE, "Modelo de Entuba de Valor de Exposição"],
  [FilesCategoryEnum.PRINCING_BATCH, "Modelo de Precificação em Lote"],
  [FilesCategoryEnum.BCHECK_BATCH, "Modelo de BCheck em Lote"],
  [FilesCategoryEnum.OFFICER_INSTRUCTIONS, "Manual de Instruções para Officer"],
  [FilesCategoryEnum.ENTUBA_PRINCING, "Modelo de Entuba de Precificação"],
  [FilesCategoryEnum.ENTUBA_BCHECK, "Modelo de Entuba BCheck"],
  [FilesCategoryEnum.FILE_PROCURACAO_AD_JUDICIA_PRIVADA, "Procuração AD Judicia Privada"],
  [FilesCategoryEnum.FILE_PROCURACAO_AD_JUDICIA_PUBLICA, "Procuração AD Judicia Publica"],
  [FilesCategoryEnum.CESSAO_FIDUCIARIA, "Cessão Fiduciária"],
  [FilesCategoryEnum.CDB, "CCB"],
  [FilesCategoryEnum.TED_DOCUMENT, "Comprovante da TED"],
  [FilesCategoryEnum.PIX_DOCUMENT, "Comprovante do PIX"],
  [FilesCategoryEnum.BOLETO_DOCUMENT, "Comprovante do Boleto"],
  [FilesCategoryEnum.EXPENSE_BATCH, "Modelo de Solicitação de despesa em lote"],
  [FilesCategoryEnum.TRADE_BATCH, "Modelo de atualização de trades em lote"],
  [FilesCategoryEnum.ORIGINATION_BATCH, "Modelo de Solicitação de cessões em lote"],
  [FilesCategoryEnum.FEE_PAYMENT_BATCH, "Modelo de Solicitação de pagamento de desepesa em lote"],
  [FilesCategoryEnum.RECONCILE_SETTLEMENT_BATCH, "Modelo de Solicitação de identificação de liquidação em lote"],
  [FilesCategoryEnum.TOGGLE_ACCRUAL_BATCH, "Modelo de Solicitação de toggle de accrual em lote"],
  [FilesCategoryEnum.INSTRUMENTO_PARTICULAR_CESSAO, "Instrumento de cessão Particular"],
  [FilesCategoryEnum.DECLARACAO_NAO_CONSTRICAO, "Declaração não constrição"],
  [FilesCategoryEnum.WHOLESALE, "Modelo Atacado"],
  [FilesCategoryEnum.EBOOK_TUTORIAL, "Ebook Tutorial"],
  [FilesCategoryEnum.AVERAGE_DISCOUNT, "Relátório de Média de deságio por tribunal"],
  [FilesCategoryEnum.RTB_DATA, "Banco de RTBs"],
  [FilesCategoryEnum.MOTOR_CREDITO_RTB_DATA, "Banco de RTBs - Motor Crédito"],
  [FilesCategoryEnum.AGENT_ORCHESTRATOR_DATA, "Orquestrador LLM"]
]);
